export default function more7days(curTime, time) {
    return curTime - time > 7 * 24 * 60 * 60 * 1000
}
